import React from 'react';
import PaymentIcons from '../payment_processors/PaymentIcons';
export default function Copyrights(_ref) {
  var appProps = _ref.appProps,
    frontendStyles = _ref.frontendStyles,
    errorScreen = _ref.errorScreen;
  var translations = appProps.translations;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bottom-section",
    style: {
      backgroundColor: frontendStyles.footerNavigation.background,
      color: frontendStyles.footerNavigation.color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: " ".concat(appProps.footerVersion == '4' || '5' ? 'bottom-section main-container' : '', " ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "left-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "copyrights"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: frontendStyles.footerNavigation.color
    }
  }, translations.general.copyright, " \xA0 \xA9 \xA0", appProps.tenantCreated, " - ", appProps.currentYear, " \xA0", appProps.storeName, ". \xA0", translations.general.all_rights_reserved), !appProps.whiteLabel && /*#__PURE__*/React.createElement("div", {
    className: "branding",
    style: {
      color: frontendStyles.footerNavigation.color
    }
  }, "\xA0 ", " ".concat(translations.general.powered_by, " "), " \xA0", /*#__PURE__*/React.createElement("a", {
    href: "https://".concat(appProps.platformUrl),
    target: "_blank",
    rel: "nofollow noindex noreferrer",
    style: {
      color: frontendStyles.footerNavigation.colorHover
    }
  }, appProps.platformName)))), !errorScreen && /*#__PURE__*/React.createElement("div", {
    className: "right-column"
  }, /*#__PURE__*/React.createElement(PaymentIcons, {
    paymentMethods: appProps.paymentMethods
  })))));
}